import { Component, inject } from '@angular/core';
import { CompanyCodeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CompanyCodeCreateDto,
  CompanyCodeDto,
  CompanyCodeExcelDownloadDto,
  CompanyCodeUpdateDto,
} from '../proxy/controlling/dtos/company-code';
import { COMPANYCODE_CONFIG, COMPANYCODE_FIELDS } from './company-code.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-company-code',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, CompanyCodeService, ConfirmationService],
  templateUrl: './company-code.html',
  styleUrl: './company-code.scss',
})
export class CompanyCode extends BaseCrudComponent<
  CompanyCodeDto,
  CompanyCodeCreateDto,
  CompanyCodeUpdateDto,
  CompanyCodeExcelDownloadDto
> {
  service = inject(CompanyCodeService);
  config = COMPANYCODE_CONFIG;
  fields = COMPANYCODE_FIELDS;

  protected prepareUpdateDto(data: any, selected: CompanyCodeDto): CompanyCodeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      oldSapCode: data.oldSapCode,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'CompanyCode';
  }
}
